import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { DataTable, Tabs, Typography, Button, makeStyles, Grid } from '../../../..';
import { Link } from 'react-router-dom';
var useStyles = makeStyles(function (theme) {
  return {
    header: {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'space-between'
    },
    mr30: {
      'margin-right': '30px'
    },
    mb30: {
      'margin-bottom': '30px'
    }
  };
});

var FranchisePastOpportunities = function FranchisePastOpportunities(_ref) {
  var translation = _ref.translation,
      wonOpportunities = _ref.wonOpportunities,
      lostOpportunities = _ref.lostOpportunities;
  var classes = useStyles();

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var _useState = useState('won'),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var contentTabHandler = function contentTabHandler(value) {
    // console.log('translationen contentTabHandler', translation.datatables)
    switch (value) {
      case 'won':
        return /*#__PURE__*/React.createElement(DataTable, {
          key: "won-opps",
          type: "opportunities",
          data: wonOpportunities,
          translation: translation ? translation.datatables.won : null
        });

      case 'lost':
        return /*#__PURE__*/React.createElement(DataTable, {
          key: "lost-opps",
          type: "opportunities",
          data: lostOpportunities,
          translation: translation ? translation.datatables.lost : null
        });

      default:
        return /*#__PURE__*/React.createElement(DataTable, {
          key: "won-opps",
          type: "opportunities",
          data: wonOpportunities,
          translation: translation ? translation.datatables.won : null
        });
    }
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: '#fafafa'
    }
  }, translation ? translation.title : 'Past opportunities'), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    component: Link,
    to: "/pipeline"
  }, translation ? translation.buttons.view_open_opportunities : 'Ongoing pipeline'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "standard",
    indicatorColor: "primary",
    textColor: "primary",
    className: classes.mb30,
    contentTabs: translation.tabs ? translation.tabs : [{
      label: 'Won',
      value: 'won'
    }, {
      label: 'Lost',
      value: 'lost'
    }]
  }), contentTabHandler(value)))];
};

export { FranchisePastOpportunities };